export const TermsSection4 = () => {
  return (
    <>
      <section id="disclaimers">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Disclaimers</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-4 uppercase">
              THE SERVICE IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; WITHOUT
              WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
            </p>
          </div>
          <p>To the fullest extent permitted by law, we disclaim all warranties, including:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              Warranties of merchantability, fitness for a particular purpose, and non-infringement
            </li>
            <li>Any warranties arising from course of dealing or usage of trade</li>
            <li>Any warranties that the Service will be uninterrupted, secure, or error-free</li>
            <li>Any warranties regarding the accuracy, reliability, or completeness of content</li>
          </ul>
          <p>
            We do not guarantee that the Service will meet your requirements or that any defects
            will be corrected. Your use of the Service is at your sole risk.
          </p>
          <p>
            Some jurisdictions do not allow the exclusion of certain warranties, so some of the
            above exclusions may not apply to you.
          </p>
        </div>
      </section>

      <section id="liability">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Limitation of Liability</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-4 uppercase">
              TO THE FULLEST EXTENT PERMITTED BY LAW, WINGROW SHALL NOT BE LIABLE FOR ANY INDIRECT,
              INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.
            </p>
          </div>
          <p>This limitation applies to damages arising from:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Use or inability to use the Service</li>
            <li>Unauthorized access to or alteration of your data</li>
            <li>Loss of profits, revenue, data, or business opportunities</li>
            <li>Third-party conduct or content on the Service</li>
            <li>Any other matter relating to the Service</li>
          </ul>
          <p>
            Our total liability for any claims arising from or related to the Service shall not
            exceed the amount you paid us in the 12 months prior to the claim, or $100, whichever is
            greater.
          </p>
          <p>
            Some jurisdictions do not allow the limitation or exclusion of liability, so some of the
            above limitations may not apply to you.
          </p>
        </div>
      </section>

      <section id="dispute-resolution">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Dispute Resolution</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">12.1 Governing Law</h3>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the
            jurisdiction where WinGrow is registered, without regard to its conflict of law
            principles.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            12.2 Informal Resolution
          </h3>
          <p>
            Before filing a formal dispute, you agree to contact us at{' '}
            <a
              href="mailto:viprielt24@gmail.com"
              className="text-blue-600 underline hover:text-blue-800"
            >
              viprielt24@gmail.com
            </a>{' '}
            to attempt to resolve the dispute informally.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">12.3 Arbitration</h3>
          <p>
            Any disputes that cannot be resolved informally shall be resolved through binding
            arbitration in accordance with the rules of a recognized arbitration organization.
          </p>
          <p>
            You agree to waive your right to a jury trial and to participate in a class action
            lawsuit.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">12.4 Exceptions</h3>
          <p>
            Either party may seek injunctive or other equitable relief in court to protect
            intellectual property rights without first engaging in arbitration.
          </p>
        </div>
      </section>

      <section id="changes">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Changes to These Terms</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            We reserve the right to modify these Terms at any time. If we make material changes, we
            will notify you by:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Posting a notice on our website</li>
            <li>Sending an email to the address associated with your account</li>
            <li>Displaying a notification when you log in to the Service</li>
          </ul>
          <p>
            Your continued use of the Service after the effective date of the revised Terms
            constitutes your acceptance of the changes. If you do not agree to the revised Terms,
            you must stop using the Service.
          </p>
          <p>
            It is your responsibility to review these Terms periodically for any updates or changes.
          </p>
        </div>
      </section>

      <section id="contact">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">14. Contact Information</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            If you have any questions, concerns, or complaints about these Terms or our Service,
            please contact us:
          </p>
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-2">WinGrow</p>
            <p className="text-gray-700">
              Email:{' '}
              <a
                href="mailto:viprielt24@gmail.com"
                className="text-blue-600 underline hover:text-blue-800"
              >
                viprielt24@gmail.com
              </a>
            </p>
            <p className="text-gray-700">Website: wingrow.io</p>
          </div>
          <p>We will make reasonable efforts to respond to your inquiry within 2 business days.</p>
        </div>
      </section>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
        <p className="font-semibold text-gray-900 mb-2">
          By using our Service, you acknowledge that you have read, understood, and agree to be
          bound by these Terms of Service.
        </p>
        <p className="text-gray-700 text-sm">Last updated: December 27, 2025</p>
      </div>
    </>
  );
};
